import type { AppLayoutPageProps } from "./app-layout-page.type";

import { Layout } from "antd";
import classNames from "classnames";

import "./app-layout-page.style.less";

const { Content } = Layout;

export const AppLayoutPage = ({ className, children }: AppLayoutPageProps) => {
  return (
    <Content className={classNames("app-layout-page", className)}>
      {children}
    </Content>
  );
};
